import { validateArguments } from '../../SignatureValidation';
export var LeftFn;
(function (LeftFn) {
    LeftFn.Name = `LEFT`;
    LeftFn.Stage = "SCALAR";
    LeftFn.Signature = `LEFT(<string>, <count>)`;
    function make(callName, args, type, role) {
        return {
            name: LeftFn.Name,
            stage: LeftFn.Stage,
            data: { role, type },
            value(...values) {
                if (values.length !== 2) {
                    throw new Error(`LEFT function expects 2 arguments ` +
                        `but received ${values.length}`);
                }
                const [value, count] = values;
                if (value == null || count == null) {
                    return null;
                }
                if (typeof value === 'string' && typeof count === 'number') {
                    if (count === 0) {
                        return '';
                    }
                    const valueArr = [...value];
                    const result = valueArr.slice(0, count).join('');
                    return result;
                }
                throw new Error(`LEFT function expects its argument to be a (string) and (number) ` +
                    `but received (${typeof value}) & (${typeof count})`);
            },
        };
    }
    LeftFn.make = make;
    function validate(callNode, callName, args) {
        return validateArguments({
            arguments: ["STRING", "INTEGER"],
            meta: {
                name: LeftFn.Name,
                signature: LeftFn.Signature,
                location: callNode.location,
            },
        }, args);
    }
    LeftFn.validate = validate;
})(LeftFn || (LeftFn = {}));
